import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useUserFollowersCount(userId?: string) {
  const { user: authUser } = useAuth();
  const [followersCount, setFollowersCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchFollowersCount = async () => {
    try {
      setLoading(true);
      
      // Use provided userId or current user's id
      const targetUserId = userId || authUser?.id;
      if (!targetUserId) return;

      // Use database function to get followers count (bypasses RLS)
      const { data, error } = await supabase.rpc('get_followers_count', {
        _user_id: targetUserId
      });

      if (error) throw error;
      setFollowersCount(data || 0);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch followers count');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const targetUserId = userId || authUser?.id;
    if (targetUserId) {
      fetchFollowersCount();
    }
  }, [userId, authUser?.id]);

  return {
    followersCount,
    loading,
    error,
    refetch: fetchFollowersCount
  };
}